import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FP610 / FP611)
// ============================================================

export interface FP610 {
  fp610_01: string;          // 包裝單號 (PK)
  fp610_10: string;          // S/C NO
  fp610_11: string | null;   // 日期 (ISO)
  fp610_12: string;          // INVOICE NO.
  fp610_13: string;          // MARKS/NOS. (SHIPPING MARK)
  fp610_14: string;          // DESCRIPTION OF GOODS
  fp610_141: string;         // DESCRIPTION 暫存
  fp610_15: string;          // 出貨方式 (材積)
  fp610_16: number;          // 明細總項數
  fp610_17: number;          // 總碼數 (YDS)
  fp610_18: number;          // 總米數 (MTS)
  fp610_19: number;          // 總毛重 (G.W.)
  fp610_20: number;          // 總淨重 (N.W.)
  fp610_21: number;          // 包裝單位 (1=R/NO. 2=B/NO. 3=C/NO.)
  fp610_22: number;          // MTS換算率
  fp610_23: number;          // N.W.換算率
  fp610_24: number;          // G.W.換算率
  fp610_25: string;          // 客戶代號
  fp610_26: number;          // 內外銷別 (1=外銷 2=內銷)
  fp610_27: number;          // 出貨單位 (1/2/3)
  fp610_28: number;          // 針織/平織 (1=針織 2=平織)
  fp610_29: string;          // 產品代號
  fp610_31: string;          // 自訂欄位1
  fp610_32: string;          // 自訂欄位2
  fp610_33: string;          // 自訂欄位3
  fp610_91: string;          // 建檔人員
  fp610_92: string | null;   // 建檔日期
  fp610_93: string;          // 修改人員

  // Associations
  details?: FP611[];
}

export interface FP611 {
  fp611_01: string;   // 包裝單號 (FK)
  fp611_02: number;   // 項次
  fp611_11: string;   // ROLL NO
  fp611_12: string;   // COLOR
  fp611_121: string;  // COLOR 描述
  fp611_21: number;   // 碼數1
  fp611_22: number;   // 碼數2
  fp611_23: number;   // 碼數3
  fp611_24: number;   // 碼數4
  fp611_31: string;   // 缸號1
  fp611_32: string;   // 缸號2
  fp611_33: string;   // 缸號3
  fp611_34: string;   // 缸號4
  fp611_41: number;   // YDS (碼數合計)
  fp611_42: number;   // MTS
  fp611_43: number;   // G.W. (毛重)
  fp611_44: number;   // N.W. (淨重)
  fp611_51: number;   // 補碼1
  fp611_52: number;   // 補碼2
  fp611_53: number;   // 補碼3
  fp611_54: number;   // 補碼4
  fp611_421: number;  // MTS精確值
  fp611_431: number;  // G.W.精確值
  fp611_441: number;  // N.W.精確值
  fp611_442: number;  // N.W.附加值
  fp611_91: string;   // 建檔人員
  fp611_92: string | null; // 建檔日期
  fp611_93: string;   // 修改人員
}

// ============================================================
// Request / Response types
// ============================================================

export interface PWP254ListResponse {
  data: FP610[];
  total: number;
  page: number;
  size: number;
}

export interface PWP254CreateRequest {
  master: Partial<FP610>;
  details: Partial<FP611>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwp254Api = {
  async list(page = 1, size = 20): Promise<PWP254ListResponse> {
    const res = await apiClient.get('/api/pwp254', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FP610> {
    const res = await apiClient.get(`/api/pwp254/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: PWP254CreateRequest): Promise<FP610> {
    const res = await apiClient.post('/api/pwp254', data);
    return res.data;
  },

  async update(id: string, data: PWP254CreateRequest): Promise<FP610> {
    const res = await apiClient.put(`/api/pwp254/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pwp254/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwp254/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
